<template>
  <div class="newMatch" :class="getClass" @click="saveNewMatch">
    <span>&nbsp;</span>
  </div>
</template>

<script>
export default {
  name: "newMatch",
  data: () => ({
    s: null
  }),
  props: {
    id: "",
    teamsId: "",
    name: "",
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    getClass() {
      // Улучшили проверку: теперь корректно ловит null, undefined и пустую строку ""
      if (!this.status) {
        return "";
      } else if (this.status === "squad") {
        return "roundgreen";
      } else if (this.status === "substitutions") {
        return "roundyellow";
      }
      return "";
    },
    status: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    saveNewMatch() {
      let newStatus = null;
      
      // Бронебойная логика: 
      // Если сейчас зеленый -> делаем желтый
      if (this.status === "squad") {
        newStatus = "substitutions";
      } 
      // Если желтый -> очищаем (null)
      else if (this.status === "substitutions") {
        newStatus = null;
      } 
      // ВО ВСЕХ ОСТАЛЬНЫХ СЛУЧАЯХ (пусто, "false", "true", любой мусор) -> делаем зеленый!
      else {
        newStatus = "squad";
      }

      // 1. Мгновенно обновляем интерфейс локально
      this.status = newStatus;

      // 2. Тихо отправляем данные на сервер
      this.$store.dispatch("SAVE_NEW_MATCH", {
        shirtnumber: this.id,
        teamsId: this.teamsId,
        matchStatus: newStatus,
        name: this.name
      });
    }
  }
};
</script>

<style scoped lang="sass">
@import "../assets/vars"
.newMatch
  height: 25px
  width: 25px
  border-radius: 50%
  &:hover
    cursor: pointer
    background-color: rgba($RoundGreen, .2)
  &.roundgreen
    &:hover
      // Было $RoundYellow, теперь зеленый фон при наведении на зеленый кружок
      background-color: rgba($RoundGreen, .4) 
  &.roundyellow
    &:hover
      // Желтый фон при наведении на желтый кружок
      background-color: rgba($RoundYellow, .4)
</style>